"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    z-index: 2;\n    position: relative;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0;\n    transition-property: background;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      focused = _ref.focused;
  var palette = theme.palette;
  return {
    backgroundColor: disabled ? theme.disabledSelectedBackground : focused ? theme.focusSelectedBackground : theme.selectedBackground,
    height: theme.height,
    borderRadius: theme.borderRadius,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    minWidth: "".concat((0, _pixelToNumber["default"])(theme.pointerWidth) * 2, "px")
  };
};

var Bar = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Bar;
exports["default"] = _default;